module.exports = __webpack_public_path__ + "img/hotdog-top-003.173935d0.jpg";